import { z } from "zod";

export const schema = z.object({
	id_banner: z.number().int("Campo id_banner é obrigatorio"),
	descricao: z.string().min(1, "Campo Descrição é obrigatório"),
	slug: z.string().nullable(),
	url_banner: z.string().nullable(),
	ordem: z.number().int().min(1, "Campo ordem é obrigatório"),
	ativo: z.boolean(),
});

export const schemaDefaultValues = {
	id_banner: 0,
	descricao: "",
	slug: "",
	url_banner: "",
	ordem: 99,
	ativo: true,
};
